module.exports = __webpack_public_path__ + "img/abyss-seal.02a0cfa6.png";